import { AUDIENCE_SUMMARY_LABEL } from "../../lib/audience-auth";
import type { McpServerCreateRequest } from "../../types";
import { formatMissingRequirements } from "../lib/gateway-form-requirements";

export function CreateFooterSummary({
  readyToCreate,
  missingRequirements,
  selectedToolCount,
  selectedApps,
  authType,
  isEditing = false,
}: {
  readyToCreate: boolean;
  missingRequirements: string[];
  selectedToolCount: number;
  selectedApps: string[];
  authType: McpServerCreateRequest["auth_type"];
  isEditing?: boolean;
}) {
  if (!readyToCreate) {
    return (
      <div className="min-w-0">
        {missingRequirements.length > 0 ? (
          <p className="text-muted-foreground text-sm">
            {formatMissingRequirements(missingRequirements)}
          </p>
        ) : (
          <p className="text-muted-foreground text-sm">
            {isEditing
              ? "Finish the required steps to save this MCP gateway."
              : "Finish the required steps to create this MCP gateway."}
          </p>
        )}
      </div>
    );
  }

  const appSummary =
    selectedApps.length === 1 ? "1 app" : `${selectedApps.length} apps`;

  return (
    <p className="min-w-0 truncate text-muted-foreground text-sm">
      {selectedToolCount} tool{selectedToolCount === 1 ? "" : "s"} ·{" "}
      {appSummary} · {AUDIENCE_SUMMARY_LABEL[authType ?? "arcade"]}
    </p>
  );
}
